import { Typography } from "antd"
import { useSelector } from "react-redux"

import { ConfirmInvitationCheckbox } from "./components/ConfirmInvitationCheckbox"
import { StepList } from "./components/StepList"
import { contentMap } from "./contentMap"
import { generateInviteEmail } from "./utils/generateInviteEmail"

import styles from "./CreditsAutomationConnectGuide.module.less"

const { Text } = Typography

// Renders per-processor "how to invite Chargeback" steps for the Automate credits flow (CHA1-3389).
// Only processors listed in the ticket have a guide; anything else (Stripe, Shopify, unknown pp)
// renders nothing. `confirmed`/`onConfirmedChange` are only meaningful when the guide has a
// confirmation checkbox (see `guideRequiresConfirmation`) - guides without one just ignore them.
export const CreditsAutomationConnectGuide = ({ pp, className, confirmed, onConfirmedChange }) => {
  const businessAccount = useSelector((state) => state.user.businessAccount)
  const guide = contentMap[pp?.toLowerCase()]

  if (!guide) return null

  const email = generateInviteEmail({ businessAccount, pp })

  return (
    <div className={className}>
      {guide.intro && (
        <Text type="secondary" className={styles.intro}>
          {guide.intro}
        </Text>
      )}
      <StepList steps={guide.steps} linkHref={guide.linkHref} variables={{ email }} />
      {guide.note && (
        <Text type="secondary" className={styles.note}>
          {guide.note}
        </Text>
      )}
      {guide.confirmTeam && (
        <ConfirmInvitationCheckbox
          team={guide.confirmTeam}
          checked={confirmed}
          onChange={onConfirmedChange}
        />
      )}
    </div>
  )
}

// Lets a parent (the Automate credits modal) know whether Submit should stay disabled until this
// processor's checkbox is ticked, without rendering anything.
export const guideRequiresConfirmation = (pp) => Boolean(contentMap[pp?.toLowerCase()]?.confirmTeam)

export default CreditsAutomationConnectGuide
